// src/components/invoices/InvoiceFooter.jsx
import React from 'react';
import useInvoiceStore from '../../store/useInvoiceStore';
import { formatCurrency } from '../../utils/formatters';

const InvoiceFooter = () => {
  const { activeInvoice, updateActiveInvoiceField } = useInvoiceStore();

  // Değerleri güvenli bir şekilde alalım
  const grandTotal = activeInvoice?.grandTotal || 0;
  const paidAmount = activeInvoice?.paidAmount || 0;
  const remainingAmount = activeInvoice?.remainingAmount ?? grandTotal;
  const exchangeRate = activeInvoice?.exchangeRate || 1;
  const currency = activeInvoice?.currency || 'TRY';
  const paymentStatus = activeInvoice?.paymentStatus || 'Unpaid';

  const paymentLabel = {
    Paid: 'Ödendi',
    PartiallyPaid: 'Kısmi Ödendi',
    Unpaid: 'Ödenmedi'
  }[paymentStatus] || 'Ödenmedi';

  const paymentClass = {
    Paid: 'bg-emerald-100 text-emerald-700',
    PartiallyPaid: 'bg-orange-100 text-orange-700',
    Unpaid: 'bg-rose-100 text-rose-700'
  }[paymentStatus] || 'bg-rose-100 text-rose-700';

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pt-8 border-t border-slate-50">
      {/* Notlar Alanı */}
      <div className="space-y-3">
      <label className="block text-xs font-bold text-slate-700">
        Açıklama
        <textarea
          value={activeInvoice?.description || ''}
          onChange={(e) => updateActiveInvoiceField('description', e.target.value)}
          className="mt-2 min-h-24 w-full rounded-2xl bg-slate-50 p-4 text-sm text-slate-900 outline-none focus:ring-2 focus:ring-slate-200"
        />
      </label>
      <textarea
        aria-label="Sevk ve fatura notları"
        placeholder="Notlar..."
        value={activeInvoice?.notes || ''}
        onChange={(e) => updateActiveInvoiceField('notes', e.target.value)}
        className="w-full h-32 p-6 bg-slate-50 rounded-3xl outline-none resize-none focus:ring-2 focus:ring-slate-200 transition-all text-slate-900 placeholder:text-slate-600 font-bold"
      />
      </div>

      {/* Toplamlar Tablosu */}
      <div className="bg-slate-50 p-8 rounded-4xl space-y-3">
        <div className="flex justify-between font-bold text-slate-900">
          <span>Ara Toplam</span>
          <span>{formatCurrency(activeInvoice?.subTotal, currency)}</span>
        </div>
        
        <div className="flex justify-between font-bold text-slate-900">
          <span>KDV Toplamı</span>
          <span>{formatCurrency(activeInvoice?.totalVat, currency)}</span>
        </div>

        <div className="h-px bg-slate-200 my-2" />

        <div className="flex justify-between items-center pt-2">
          <span className="text-xs font-black text-slate-900 uppercase tracking-wider">
            Genel Toplam
          </span>
          <span className="text-3xl font-black text-slate-900">
            {formatCurrency(grandTotal, currency)}
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-4">
          <div className="bg-white rounded-2xl px-4 py-3">
            <p className="text-[10px] font-black text-slate-900 uppercase tracking-wider">Ödenen Tutar</p>
            <p className="text-sm font-black text-emerald-600 mt-1">{formatCurrency(paidAmount, currency)}</p>
          </div>
          <div className="bg-white rounded-2xl px-4 py-3">
            <p className="text-[10px] font-black text-slate-900 uppercase tracking-wider">Kalan Borç</p>
            <p className="text-sm font-black text-rose-600 mt-1">{formatCurrency(remainingAmount, currency)}</p>
          </div>
          <div className="bg-white rounded-2xl px-4 py-3 flex flex-col justify-center">
            <p className="text-[10px] font-black text-slate-900 uppercase tracking-wider">Ödeme Durumu</p>
            <span className={`w-fit mt-1 px-3 py-1 rounded-lg text-[10px] font-black ${paymentClass}`}>
              {paymentLabel}
            </span>
          </div>
        </div>

        {/* Dövizli Fatura ise TL Karşılığı */}
        {currency !== 'TRY' && (
          <div className="mt-4 pt-4 border-t border-dashed border-slate-300 text-xs font-bold text-slate-900">
            <div className="flex justify-between items-center">
              <span>TL Karşılığı:</span>
              <span className="text-slate-900 font-black text-sm">
                {/* BURASI DÜZELTİLDİ: Tutar kurla çarpıldı ve birim 'TRY' yapıldı */}
                {formatCurrency(grandTotal * exchangeRate, 'TRY')}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceFooter;
